import Entities from 'STORE';

export const onNotificationClose = (notification: Notification): void => {
  Entities.pushNotifications.removeNotificationByRef(notification);
};
